<svg width="92" height="92" viewBox="0 0 92 92" fill="none" xmlns="http://www.w3.org/2000/svg">
  <!-- Shadow -->
  <rect x="20" y="20" width="54" height="62" rx="8" fill="#004E6D" opacity="0.1"/>
  <!-- Clipboard body -->
  <rect x="18" y="16" width="54" height="62" rx="8" fill="#E8F4FA"/>
  <rect x="18" y="16" width="54" height="62" rx="8" stroke="#0596D0" stroke-width="2"/>
  <!-- Clipboard clip top -->
  <rect x="33" y="10" width="24" height="14" rx="4" fill="#0596D0"/>
  <rect x="37" y="8" width="16" height="8" rx="3" fill="#004E6D"/>
  <circle cx="45" cy="12" r="2" fill="#E8F4FA"/>
  <!-- Checkline 1 - completed -->
  <rect x="28" y="34" width="8" height="8" rx="2" fill="#0596D0"/>
  <path d="M30 38.5L32.5 41L36.5 35.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <rect x="42" y="36" width="22" height="3.5" rx="1.75" fill="#0596D0" opacity="0.5"/>
  <!-- Checkline 2 - completed -->
  <rect x="28" y="48" width="8" height="8" rx="2" fill="#0596D0"/>
  <path d="M30 52.5L32.5 55L36.5 49.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <rect x="42" y="50" width="18" height="3.5" rx="1.75" fill="#0596D0" opacity="0.5"/>
  <!-- Checkline 3 - pending -->
  <rect x="28" y="62" width="8" height="8" rx="2" fill="#0596D0" opacity="0.25"/>
  <rect x="28" y="62" width="8" height="8" rx="2" stroke="#0596D0" stroke-width="1.5" stroke-dasharray="2 2"/>
  <rect x="42" y="64" width="14" height="3.5" rx="1.75" fill="#0596D0" opacity="0.2"/>
</svg>
